// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jTHTm","image":"styles_image__2rNzX","arrowImage":"styles_arrowImage__2Kc2o"};